export default "__VITE_ASSET__Jht2gscg__"